export default __webpack_public_path__ + "static/media/Smart Mobility.f640dd97.pdf";